

















































import Vue from "vue";
import Pagination from "@/components/detail/Pagination.vue";
import CommentLoader from "@/components/skeleton/CommentLoader.vue";
import CommentDeleteDialog from "@/components/detail/CommentDeleteDialog.vue";
import CommentItem from "@/components/detail/CommentItem.vue";
import CommentInput from "@/components/detail/CommentInput.vue";
import Empty from "@/components/Empty.vue";
import eventEmitter from "@/utils/eventEmitter";
import { formatPublishTime } from "@/utils/filters";
import constants from "@/utils/constants";
import ssoMixin from "@/mixins/sso";
import { ICommentParams } from "@/types/post";

export default Vue.extend({
  name: "comment",
  mixins: [ssoMixin],
  filters: {
    formatPublishTime,
  },
  components: {
    CommentLoader,
    Pagination,
    CommentDeleteDialog,
    CommentInput,
    CommentItem,
    Empty,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: "",
    },
    tid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: true,
      commentToDelete: {},
      commentLevel: "1",
      deleteVisible: false,
      autofocus: false,
    };
  },
  computed: {
    curUser() {
      return this.$store.state.user.curUser;
    },
    hasLogin() {
      return this.curUser.userId !== "0";
    },
    feedComment() {
      return this.$store.state.post.feedComment;
    },
    comments() {
      return this.feedComment.list;
    },
    users() {
      return this.feedComment.users;
    },
    praises() {
      return this.feedComment.is_praises;
    },
    hasMore() {
      return this.feedComment.hasMore;
    },
    total() {
      return this.feedComment.total;
    },
    userAvatar() {
      if (this.hasLogin && this.curUser.portrait_url) {
        return this.curUser.portrait_url;
      }
      return constants.DEFAULT_AVATAR_URL;
    },
  },
  async mounted() {
    this.$store.commit("drive/setUploadTask", []);
    this.$store.commit("drive/clearPanFileSelected", []);

    eventEmitter.on("comment-delete", ({ item, level }: any) => {
      this.deleteVisible = true;
      this.commentToDelete = item;
      this.commentLevel = level;
    });

    eventEmitter.on("resource-comment", () => {
      const topCommentInput = this.$refs.topCommentInput;
      if (topCommentInput && topCommentInput.$refs.commentInput) {
        const realInput = topCommentInput.$refs.commentInput;
        realInput.focus();
      }
    });

    // control that one reply input expands
    eventEmitter.on("start-reply", (item: { comment_id: string }) => {
      this.collapseInput(item);
    });

    this.getCommentList();

    this.stat("xiaozhan_comment_section_show", {
      cardID: this.info ? this.info.id : "",
      upUid:
        this.info && this.info.user_info ? this.info.user_info.user_id : "",
    });
  },
  beforeDestroy() {
    eventEmitter.off("comment-delete", 0);
  },
  methods: {
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    async getCommentList(refresh = true) {
      const tid = this.tid;
      const params: ICommentParams = {
        refresh,
        tid,
      };
      await this.$store.dispatch("post/fetchFeedComment", params);
      this.loading = false;
    },
    loadMore(visible: boolean) {
      if (visible) {
        this.getCommentList(false);
      }
    },
    handleCommentSuccess(item: { comment_id: string }) {
      this.collapseInput(item);
    },
    collapseInput(item: { comment_id: string }) {
      const cid = item.comment_id;
      const commentItems = this.$refs.commentItem;
      if (!commentItems) {
        return;
      }

      for (let item of commentItems) {
        if (
          item.$refs &&
          item.$refs["subCommentInput"] &&
          item.$refs["subCommentInput"].info.comment_id !== cid
        ) {
          item.$refs["subCommentInput"].closeReplyInput();
        }

        if (
          item.$refs &&
          item.$refs["subCommentList"] &&
          item.$refs["subCommentList"].$refs
        ) {
          const subCommentList = item.$refs["subCommentList"];
          const subCommentItems = subCommentList.$refs["subCommentItem"];
          if (subCommentItems) {
            for (let subItem of subCommentItems) {
              if (
                subItem.$refs &&
                subItem.$refs["subCommentInput"] &&
                subItem.$refs["subCommentInput"].info.comment_id !== cid
              ) {
                subItem.$refs["subCommentInput"].closeReplyInput();
              }
            }
          }
        }
      }
    },
  },
});
